// src/app/helpers/license-checker.service.ts
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LicenseCheckerService {
    constructor() { }

    public checkLicense(key: string): boolean {
        const value = sessionStorage.getItem(key);
        return value !== null && value === 'true';
      }
}
